import React from "react";
import { Location16Regular, Mail16Regular, Phone16Regular } from "@fluentui/react-icons";
import InputReadOnlyField from "../form/field/read-only/Input";
import PhoneReadOnlyField from "../form/field/read-only/Phone";

const RelationContactInfo = ({ relationContact }) => {
  return (
    <>
      <InputReadOnlyField
        value={`
          ${relationContact.Person.AddressPrimary.address}, 
          ${relationContact.Person.AddressPrimary.postcode},
          ${relationContact.Person.AddressPrimary.city}
        `}
        icon={<Location16Regular />}
      />
      <PhoneReadOnlyField value={relationContact.Person.PhoneNumbers} icon={<Phone16Regular />} />
      <InputReadOnlyField value={`${relationContact.Person.emailPrimary}`} icon={<Mail16Regular />} />
    </>
  );
};

export default RelationContactInfo;
